// Eventos de teste (is_test=true) servem para a equipe ensaiar o fluxo
// completo. Por isso ficam visíveis para qualquer staff logado, qualquer um
// com algum papel (Admin, Inspetor, Juiz de Combate/Round, Pit Runner,
// Organizador), inclusive juízes que precisam participar dos testes.
// Some apenas para o público/anônimo (sem nenhum papel).
const isStaff = (rootGetters) => {
  const user = rootGetters['users/getUser']
  const roles = (user && user.roles) || []
  return roles.length > 0
}

const getters = {
  getEvents: ({ events }) => events,
  // Seleção explícita de evento (cru). Diferente de getCurrentEvent, que
  // auto-seleciona um evento como fallback. Aqui é null até o usuário entrar
  // num evento (pela tela Eventos). Usado pela navbar p/ revelar os menus de evento.
  getSelectedEventId: ({ currentEventId }) => currentEventId,
  getVisibleEvents: ({ events }, getters, rootState, rootGetters) => {
    if (isStaff(rootGetters)) return events
    return events.filter(e => !e.is_test)
  },
  getCurrentEvent: ({ currentEventId }, getters) => {
    const list = getters.getVisibleEvents
    if (!list.length) return null
    if (currentEventId) return list.find(e => e.id === currentEventId) || null
    const active = list.find(e => e.endat && new Date(e.endat) > new Date())
    return active || list[list.length - 1]
  },
  getCurrentEventId: (state, getters) => {
    return getters.getCurrentEvent ? getters.getCurrentEvent.id : null
  },
  getCurrentEventArenaId: (state, getters) => {
    return getters.getCurrentEvent ? (getters.getCurrentEvent.arena_id || 2) : 2
  },
  getEventSummary: ({ eventSummary }) => eventSummary
}

export default getters
